import { Component, ElementRef, Input, OnInit, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { Role } from '../models/role.model';
import { MatMenuTrigger } from '@angular/material/menu';
import { EmployeeModel } from 'src/app/Models/EmpCareerUser.model';
import { CareerPathService } from '../employee-career-path.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { Grade } from '../models/grade.model';
import { ToastrService } from 'ngx-toastr';
import { MatTooltip } from '@angular/material/tooltip';


@Pipe({ name: 'tooltipList' })
export class TooltipListPipe implements PipeTransform {

  transform(lines: string[]): string {

    let list: string = '';

    lines.forEach(line => {
      list += '• ' + line + '\n';
    });

    return list;
  }
}
@Component({
  selector: 'app-department-role',
  templateUrl: './department-role.component.html',
  styleUrls: ['./department-role.component.css']
})
export class DepartmentRoleComponent implements OnInit {

  @Input()
  public role: Role;
  @Input() practiceId: number;
  @Input() departmentId: number;
  @Input() isMyCareer: boolean;
  @Input() practiceName: string;
  @Input() departmentName: string;
  @ViewChild(MatMenuTrigger) triggerBtn: MatMenuTrigger;
  @ViewChild('tooltipTrigger') tooltipTrigger: ElementRef;
  @ViewChild(MatTooltip) tooltip: MatTooltip;
  showHeaderCell = false;
  employeeDetails: EmployeeModel;
  programAndCourses: any;
  totalPrograms: number;
  totalCourses: number;
  constructor(private service: CareerPathService, private spinner: NgxSpinnerService, private router: Router,private toastr:ToastrService) { }

  ngOnInit(): void {
    // this.employeeDetails = this.authService.getUserInfo();
    const storedData = localStorage.getItem('empCareerUserDetails');
    if (storedData) {
      this.employeeDetails = JSON.parse(storedData);
    }

    // setTimeout(() => {
    //   this.tooltip.show();
    // }, 100);
  }

  public orderGrades(grades: Grade[]) {
    return this.doOrder(grades, [])

  }

  public doOrder(grades: Grade[], orderedGrades: Grade[]) {
    if (grades.length > 0) {
      const grade = grades[0];
      orderedGrades.push(grades[0]);
      orderedGrades = this.moveLeft(grades, orderedGrades, grade.previousGradeId);
      orderedGrades = this.moveRight(grades, orderedGrades, grade.id);
      return orderedGrades;
    }
    return orderedGrades;
  }

  public moveLeft(grades: Grade[], orderedGrades: Grade[], previousId?: number) {
    if (previousId) {
      const leftNode = grades.find(x => x.id == previousId)
      if (leftNode) {
        orderedGrades.unshift(leftNode);
        orderedGrades = this.moveLeft(grades, orderedGrades, leftNode.previousGradeId)
      }
    }
    return orderedGrades;
  }

  public moveRight(grades: Grade[], orderedGrades: Grade[], currentId: number) {
    const rightNode = grades.find(x => x.previousGradeId == currentId)
    if (rightNode) {
      orderedGrades.push(rightNode);
      orderedGrades = this.moveRight(grades, orderedGrades, rightNode.id);
    }
    return orderedGrades;
  }

  openMatMenu() {
    this.triggerBtn.openMenu();
  }

  getProgramsAndCourses(roleId: any, gradeId: any) {
    var model = {
      departmentID: this.departmentId,
      practiceID: this.practiceId,
      roleID: roleId,
      gradeID: gradeId
    };
    this.spinner.show();
    this.service.fetchProgramsAndCourses(model).subscribe((res: any) => {
      if (res) {
        this.totalCourses = res.courses;
        this.totalPrograms = res.programs;
      }
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
      this.toastr.error("Fetching ProgramsAndCourses Failed")


    })
  }

  goToProgram(data) {
    if (data.programs.length < 1 || data.courses < 1) return;
    var gradeText = data.name + " Programs";
    this.service.setCareerrPathProgramIds(data.programs);
    this.router.navigateByUrl('/Home/employee-career/employee-Career-path/program-catalogue', { state: { selectedGrade: gradeText } });
  }

}
